import axios from 'axios'
import authHeader from "./services/auth-header";
import router from "./router";
import store from "./store";

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL
})

 instance.interceptors.request.use(
    (config) => {
      config.headers = authHeader();
      return config;
    },
    (err) => {
      return Promise.reject(err);
    }
  );
  
  instance.interceptors.response.use(
    (response) => {
      if (response.status === 200 || response.status === 201) {
        return Promise.resolve(response);
      } else {
        return Promise.reject(response);
      }
    },
    (error) => {
      if (error.response.status) {
        switch (error.response.status) {
          case 401:
            store.dispatch("auth/logout");
            router.push("/login");
            break;
          case 403:
            router.push("/unauthorized");
            break;
        }
        return Promise.reject(error.response);
      }
    }
  );

  export default instance